import React from "react";
import { SbpMark } from "./SbpMark";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { useLang } from "../lib/i18n";

export const TrustBar = () => {
  const { t } = useLang();
  return (
    <header
      data-testid="trust-bar"
      className="sticky top-0 z-20 bg-background border-b border-border"
    >
      <div className="max-w-md mx-auto px-4 py-3 flex items-center justify-between gap-2">
        <div data-testid="trust-bar-fva-mark" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-[hsl(var(--primary))] flex items-center justify-center">
            <span className="text-white font-display font-bold text-sm">N</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-sm tracking-tight">{t.brand}</div>
            <div className="flex items-center gap-1" data-testid="trust-bar-sbp-mark">
              <SbpMark size={14} />
              <span className="text-[11px] font-semibold text-muted-foreground">{t.sbp}</span>
            </div>
          </div>
        </div>
        <LanguageSwitcher />
      </div>
    </header>
  );
};
